import checkout from "./form";

const {
  formField: { name, id },
} = checkout;

const initialValues = {
  [name.name]: "",
  [id.name]: 0,
};

export default initialValues;
